import { useSearchParams } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@easyflow/ui-frontend/components/ui/tabs';
import MessagingSettings from './MessagingSettings';
import EmailAccounts from '@/pages/messaging/EmailAccounts';
import TelegramSettingsTab from '@/components/messaging/TelegramSettingsTab';
import MetaSettingsTab from '@/components/messaging/MetaSettingsTab';

type CommTab = 'twilio' | 'email' | 'telegram' | 'messenger' | 'instagram';

const VALID_TABS: readonly CommTab[] = ['twilio', 'email', 'telegram', 'messenger', 'instagram'];

function normalizeTab(raw: string | null): CommTab {
  return VALID_TABS.includes(raw as CommTab) ? (raw as CommTab) : 'twilio';
}

export default function CommunicationSettings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = normalizeTab(searchParams.get('tab'));

  const handleTabChange = (value: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', value);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="p-6 w-full">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Settings className="w-6 h-6" />
          Impostazioni Comunicazione
        </h1>
        <p className="text-gray-500 text-sm mt-1">
          Twilio, Account Email, Telegram e canali Meta in un unico posto.
        </p>
      </div>

      <Tabs value={tab} onValueChange={handleTabChange} className="w-full">
        <TabsList>
          <TabsTrigger value="twilio">Twilio</TabsTrigger>
          <TabsTrigger value="email">Account Email</TabsTrigger>
          <TabsTrigger value="telegram">Telegram</TabsTrigger>
          <TabsTrigger value="messenger">Messenger</TabsTrigger>
          <TabsTrigger value="instagram">Instagram Direct</TabsTrigger>
        </TabsList>

        <TabsContent value="twilio" className="mt-4">
          <MessagingSettings />
        </TabsContent>
        <TabsContent value="email" className="mt-4">
          <EmailAccounts />
        </TabsContent>
        <TabsContent value="telegram" className="mt-4">
          <TelegramSettingsTab />
        </TabsContent>
        <TabsContent value="messenger" className="mt-4">
          <MetaSettingsTab platform="messenger" />
        </TabsContent>
        <TabsContent value="instagram" className="mt-4">
          <MetaSettingsTab platform="instagram" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
